import React, { useEffect, useState } from 'react';
import { supabase } from '../../supabaseClient';
import './Admin.css';

const AdminSettings = () => {
  const [form, setForm] = useState({ free_shipping_threshold: '', flat_shipping_charge: '' });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    supabase.from('shipping_settings').select('*').eq('id', 1).single().then(({ data }) => {
      if (data) setForm({ free_shipping_threshold: data.free_shipping_threshold, flat_shipping_charge: data.flat_shipping_charge });
      setLoading(false);
    });
  }, []);

  const handleSave = async () => {
    setSaving(true);
    setSaved(false);
    await supabase.from('shipping_settings').update({
      free_shipping_threshold: parseFloat(form.free_shipping_threshold) || 0,
      flat_shipping_charge: parseFloat(form.flat_shipping_charge) || 0,
      updated_at: new Date().toISOString(),
    }).eq('id', 1);
    setSaving(false);
    setSaved(true);
    setTimeout(() => setSaved(false), 2500);
  };

  if (loading) return <div className="admin-loading"><div className="admin-spinner" /><p>Loading...</p></div>;

  return (
    <div>
      <div className="admin-page-header">
        <div>
          <h1 className="admin-page-title">Settings</h1>
          <p className="admin-page-sub">Store-wide shipping rules</p>
        </div>
      </div>

      <div className="admin-card" style={{maxWidth: 480}}>
        <h3 style={{fontSize:'1rem', fontWeight:600, marginBottom:'0.35rem'}}>🚚 Shipping</h3>
        <p style={{fontSize:'0.8rem', color:'var(--sage)', marginBottom:'1.25rem'}}>
          Orders above the free-shipping amount ship free. Everything below it is charged the flat rate.
        </p>

        <div style={{display:'flex', flexDirection:'column', gap:'1rem'}}>
          <div className="form-group">
            <label>Free Shipping Above (₹)</label>
            <input type="number" value={form.free_shipping_threshold}
              onChange={e => setForm({...form, free_shipping_threshold: e.target.value})}
              placeholder="500" />
          </div>
          <div className="form-group">
            <label>Flat Shipping Charge (₹)</label>
            <input type="number" value={form.flat_shipping_charge}
              onChange={e => setForm({...form, flat_shipping_charge: e.target.value})}
              placeholder="60" />
          </div>
        </div>

        <div style={{display:'flex', alignItems:'center', gap:'1rem', marginTop:'1.5rem'}}>
          <button className="btn btn-primary" onClick={handleSave} disabled={saving}>
            {saving ? 'Saving...' : 'Save Changes'}
          </button>
          {saved && <span style={{color:'#27ae60', fontSize:'0.85rem', fontWeight:600}}>✓ Saved</span>}
        </div>
      </div>
    </div>
  );
};

export default AdminSettings;
